export enum FlaggedKitsFormValue {
  KIT_NO = 'kitNo',
}
